import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Heart } from 'lucide-react';
import PriceDisplay from './PriceDisplay';

const ProductCard = ({ product, onAddToCart }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isFavorite, setIsFavorite] = useState(false);

  return (
    <div
      className="group bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Link to={`/product/${product.id}`} className="block relative overflow-hidden">
        {/* Discount badge */}
        {product.discount > 0 && (
          <div className="absolute top-3 left-3 bg-red-500 text-white px-3 py-1 rounded-full text-sm font-bold z-10">
            -{product.discount}%
          </div>
        )}

        {/* Favorite button */}
        <button
          className="absolute top-3 right-3 w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-md hover:bg-red-50 transition-colors z-10"
          onClick={(e) => {
            e.preventDefault();
            setIsFavorite(!isFavorite);
          }}
        >
          <Heart
            size={18}
            className={isFavorite ? 'fill-red-500 text-red-500' : 'text-gray-400'}
          />
        </button>

        {/* Product image */}
        <div className="aspect-square bg-gray-50 overflow-hidden">
          <img
            src={isHovered && product.image2 ? product.image2 : product.image}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500 border-2 border-gray-300 shadow-sm"
          />
        </div>
      </Link>

      {/* Product info */}
      <div className="p-4">
        <Link to={`/product/${product.id}`}>
          <h3 className="text-sm font-medium text-gray-800 line-clamp-2 hover:text-red-600 transition-colors mb-2 h-10">
            {product.name}
          </h3>
        </Link>

        <div className="mb-3">
          <PriceDisplay 
            price={product.price}
            oldPrice={product.old_price}
            discount={product.discount}
            size="medium"
          />
        </div>

        {/* Add to cart button */}
        <button
          onClick={() => onAddToCart && onAddToCart(product)}
          className="w-full bg-red-600 text-white py-2.5 rounded-lg hover:bg-red-700 transition-all duration-300 flex items-center justify-center gap-2 font-medium group/btn"
        >
          <ShoppingCart size={18} className="group-hover/btn:scale-110 transition-transform" />
          Sepete Ekle
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
